import { render } from "./EnVersion.vue?vue&type=template&id=589eaeab"
import script from "./EnVersion.vue?vue&type=script&lang=js"
export * from "./EnVersion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GoogleDrive\\Projects\\Vue\\_published\\ksaien\\ksaien\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__